/* Almasea Editorial: small vanilla JS layer. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Dialogs (menu, search, cart) ---------- */
  /* Opening one drawer closes any other that is open (the menu has search and cart buttons in its top row). Only the search overlay puts the cursor in its search box; the others move focus to their panel, which draws no outline, so no focus ring appears around the close button. */
  function openDialog(id) {
    var d = document.getElementById(id);
    if (!d || d.open) return;
    $$('dialog.drawer[open]').forEach(function (o) { if (o !== d) o.close(); });
    d.showModal();
    if (id === 'search-dialog') { var f = d.querySelector('input[type="search"]'); if (f) f.focus(); return; }
    var p = d.querySelector('[data-drawer-focus]'); if (p) p.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog(opener.getAttribute('data-open')); return; }
    var closer = e.target.closest('[data-close]');
    if (closer) { var dlg = closer.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('drawer')) e.target.close();
  });

  /* ---------- Mega menu ---------- */
  var megas = $$('[data-mega]');
  function closeMegas(except) {
    megas.forEach(function (m) {
      if (m === except) return;
      var b = $('[data-mega-toggle]', m), p = $('.mega__panel', m);
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.classList.add('hidden');
    });
  }
  megas.forEach(function (m) {
    var b = $('[data-mega-toggle]', m), p = $('.mega__panel', m), t;
    function open() { clearTimeout(t); closeMegas(m); b.setAttribute('aria-expanded', 'true'); p.classList.remove('hidden'); }
    function close() { t = setTimeout(function () { b.setAttribute('aria-expanded', 'false'); p.classList.add('hidden'); }, 120); }
    b.addEventListener('click', function () { b.getAttribute('aria-expanded') === 'true' ? close() : open(); });
    m.addEventListener('mouseenter', open); m.addEventListener('mouseleave', close);
    m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMegas(); });

  /* ---------- Cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('hidden', !n); });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var html = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      var fresh = $('#cart-drawer-content', html), cur = $('#cart-drawer-content');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    });
  }
  function cartJson() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (!q) return;
    e.preventDefault();
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(q.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-quantity'), 10) }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (q.closest('#cart-drawer')) return refreshDrawer();
        window.location.reload();
      });
  });

  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return cartJson(); })
        .then(function (cart) { setCount(cart.item_count); return refreshDrawer(); })
        .then(function () { openDialog('cart-drawer'); })
        .catch(function (err) {
          var m = $('[data-form-error]', form); if (m) { m.textContent = (err && err.description) || 'Sorry, we could not add that. Please try again.'; m.hidden = false; }
        })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  });

  /* ---------- Quantity stepper (product page) ---------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]'); if (!b) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      input.value = v;
    });
  });

  /* ---------- Gallery (scroll-snap track + thumbs + dots) ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g), thumbs = $$('[data-gallery-thumb]', g), dots = $$('[data-gallery-dot]', g);
    if (!track) return;
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = $('[data-variants-json]', form.parentNode) || $('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('input[name="id"]', form), btn = $('[type="submit"]', form), price = $$('[data-price]');
    var money = function (c) { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(c / 100); };
    /* Show the image assigned to the chosen variant (set under Variants in Shopify admin). */
    function showVariantImage(v, smooth) {
      var pos = v && v.featured_media && v.featured_media.position;
      var track = $('[data-gallery-track]');
      if (!pos || !track || pos < 2 && track.scrollLeft < 2) return;
      track.scrollTo({ left: (pos - 1) * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    function update() {
      var chosen = $$('[data-option-index]:checked', form).sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; }).map(function (i) { return i.value; });
      var v = variants.filter(function (x) { return x.options.join('|') === chosen.join('|'); })[0];
      if (!v) { btn.setAttribute('aria-disabled', 'true'); return; }
      idInput.value = v.id;
      btn.setAttribute('aria-disabled', v.available ? 'false' : 'true');
      var label = $('[data-atc-label]', btn); if (label) label.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
      price.forEach(function (p) { p.textContent = money(v.price); });
      showVariantImage(v, true);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-option-index]')) update(); });
    /* Opening a link that already names a variant (?variant=...) shows that variant's image straight away. */
    var first = variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0];
    if (first && /[?&]variant=/.test(window.location.search)) showVariantImage(first, false);
  });

  /* ---------- "Load more" keeps a real ?page=N link for crawlers ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-load-more]'); if (!a) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    fetch(a.href).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var grid = $('[data-grid]'), more = $('[data-grid]', doc);
      if (grid && more) { $$('[data-grid] > *', doc).forEach(function (n) { grid.appendChild(document.importNode(n, true)); }); }
      var next = $('[data-load-more]', doc);
      if (next) { a.href = next.href; a.removeAttribute('aria-busy'); } else { a.parentNode.removeChild(a); }
    });
  });
})();

/* ---------- Generic carousel (reviews) ---------- */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), function (c) {
    var track = c.querySelector('[data-carousel-track]'), dots = c.querySelectorAll('[data-carousel-dot]');
    if (!track) return;
    function go(d) { track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' }); }
    var p = c.querySelector('[data-carousel-prev]'), n = c.querySelector('[data-carousel-next]');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }, { passive: true });
  });
})();